<template>
  <div class="news">
    <InnerHeader
      :cover="require('../../assets/img/news/cover.jpg')"
      :bgColor="'#164194'"
      :bgPosition="'0 40%'"
      :links="links"
    />
    <News v-if="!$route.query.id"/>
    <NewsPreview v-else-if="$route.query.id"/>
  </div>
</template>

<script>
import InnerHeader from '../shared/InnerHeader';
import News from './News';
import NewsPreview from './NewsPreview';
export default {
  components: {
    InnerHeader,
    News,
    NewsPreview
  },
  computed: {
    links() {
      return [
        {
          name: this.$t('nav6-1'),
          url: '/news'
        },
        {
          name: this.$t('nav6-2'),
          url: '/news?type=media'
        },
        {
          name: this.$t('nav6-4'),
          url: '/news?type=kcm-today'
        },
        // {
        //   name: this.$t('nav6-3'),
        //   url: '/news?type=gallery'
        // }
      ];
    }
  },
  mounted() {
    document.title = this.$t('title6');
  },
  destroyed() {
    document.title = this.$t('title0');
  }
};
</script>

<style>
</style>
